export default {
  am: 'am',
  ar: 'sy',
  az: 'az',
  bn: 'bd',
  be: 'be',
  ca: 'es-ca',
  cs: 'cz',
  de: 'de',
  en: 'gb',
  es: 'es',
  et: 'et',
  fa: 'ir',
  fr: 'fr',
  bg: 'bg',
  ha: 'ng',
  hi: 'in',
  hu: 'hu',
  hy: 'am',
  it: 'it',
  ja: 'jp',
  jv: 'id',
  km: 'km',
  ko: 'kr',
  lv: 'lv',
  mr: 'in',
  ms: 'my',
  pl: 'pl',
  pt: 'pt',
  ro: 'ro',
  ru: 'ru',
  sw: 'ke',
  ta: 'lk',
  te: 'in',
  th: 'th',
  tr: 'tr',
  uk: 'ua',
  uz: 'uz',
  vi: 'vn',
  zh: 'cn',
  nl: 'nl'
};
